import * as React from "react";

import { noop } from "../../../../../Common/TypingUtils";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { VALUE_EDITED } from "../../metricsAction";

export type MetricValue = null | string | number | boolean | undefined | AbsoluteModelPath;

export type TrackCallback = (action: string, options?: { [key: string]: MetricValue }) => void;

const MetricsProviderContext = React.createContext<TrackCallback>(noop);

export const MetricsProviderContextProvider = MetricsProviderContext.Provider;

export function useMetrics(): TrackCallback {
    return React.useContext(MetricsProviderContext);
}

export type ValueCallback = (value: string) => void;

export function useValueEditMetrics(
    path: AbsoluteModelPath
): [trackStartEdit: ValueCallback, trackFinishEdit: ValueCallback] {
    const [initialValue, setInitialValue] = React.useState<string>();
    const track = useMetrics();

    const handleStartEdit = React.useCallback((value: string) => {
        setInitialValue(value);
    }, []);

    const handleFinishEdit = React.useCallback(
        (nextValue: string) => {
            if (initialValue === nextValue) {
                return;
            }
            track(VALUE_EDITED, {
                path: path,
                oldValue: initialValue,
                newValue: nextValue,
            });
        },
        [initialValue, path]
    );

    return [handleStartEdit, handleFinishEdit];
}
